export default __webpack_public_path__ + "static/ben_bw-b49032a1a154af976f908db2991a7806.jpeg";